import { useState } from "react";
import { FileSpreadsheet, FileText, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { download } from "@/lib/analyse";

/** Exports CONTEXTUELS à l'onglet actif : « export = ce que je vois ». */
export const ExportsInventaire = ({ onglet, params }) => {
  const [busy, setBusy] = useState(null);
  const run = async (k, url, ext) => {
    setBusy(k);
    try {
      await download(url, { onglet, ...params }, `inventaire_${onglet}.${ext}`);
      toast.success("Export téléchargé");
    } catch (e) {
      toast.error(e.message || "Échec de l'export");
    } finally {
      setBusy(null);
    }
  };
  const B = ({ k, icon: Icon, label, url, ext }) => (
    <button data-testid={`inv-export-${k}`} disabled={!!busy} onClick={() => run(k, url, ext)}
      className="h-7 px-2.5 text-[11px] font-semibold bg-card border border-border rounded-sm flex items-center gap-1.5 hover:bg-muted disabled:opacity-50">
      {busy === k ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Icon className="h-3.5 w-3.5 text-primary" />}
      {label}
    </button>
  );
  return (
    <div data-testid="inv-exports" className="flex flex-wrap items-center gap-2">
      <B k="excel" icon={FileSpreadsheet} label="Excel" url="/inventaire/export/excel" ext="xlsx" />
      <B k="pdf" icon={FileText} label="PDF" url="/inventaire/export/pdf" ext="pdf" />
    </div>
  );
};
